import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { BuildingContactRoleService } from '@http/clients/building-contact-role.service';
import { GenericDropdownMultiselectComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-opportunity-company-role-form-editor',
    templateUrl: './report-opportunity-company-role-form-editor.component.html',
    styleUrls: ['./report-opportunity-company-role-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportOpportunityCompanyRoleFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportOpportunityCompanyRoleFormEditorComponent extends FormEditorBase<number[] | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Company Role');
    placeholderText = input<string>('Select Company Role');

    private readonly buildingContactRoleService = inject(BuildingContactRoleService);

    async ngOnInit(): Promise<void> {
        const roles = await this.buildingContactRoleService.getByUsage(2, undefined);
        this.items.set(roles);
        this.selectedItems.set(this.mapValueToSelectedItems(this.selectedValue() ?? null));
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): number[] | null {
        const selected = this.selectedItems() ?? [];
        if (!selected.length) return null;
        return selected.map((item) => Number(item.id));
    }

    protected override mapValueToSelectedItems(value: number[] | null): any[] {
        if (!value?.length) return [];
        const selectedIds = new Set(value.map((id) => Number(id)));
        return (this.items() ?? []).filter((item) => selectedIds.has(Number(item.id)));
    }
}
